var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"3px dashed red","margin":"30px","padding":"10px"}},[_vm._v("\n    Error!\n    "),_c('hr')])}]

export { render, staticRenderFns }